import Vue from 'vue'
import moment from 'moment'

moment.locale('id')

export const generateRandomStr = (length = 10) => {
  let result = ''
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length
  for (let i = 0; i < length; i + 1) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

export const clientKeyMidtrans = process.env.VUE_APP_CLIENT_KEY_MIDTRANS_PAYMENT
export const kirimEmailConfig = {
  token: process.env.VUE_APP_KIRIMEMAIL_TOKEN,
  username: process.env.VUE_APP_KIRIMEMAIL_USERNAME,
}

export const NoSpace = e => {
  const charCode = e.which ? e.which : e.keyCode
  if (charCode === 32) {
    e.preventDefault()
  }
  return true
}
export const isNumber = evt => {
  const charCode = evt.which ? evt.which : evt.keyCode
  if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 48) {
    evt.preventDefault()
  }
  return true
}
export const isAlphabet = e => {
  const char = String.fromCharCode(e.keyCode)
  if (/^[A-Za-z]+$/.test(char)) {
    return true
  }
  if (/\s/.test(char)) {
    return true
  }
  e.preventDefault()
  return false
}

export const capitalize = value => {
  const result = value
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')

  return result
}

export const toUpperCase = value => {
  if (!value) return ''
  return String(value).toUpperCase()
}

export const checkImage = url => new Promise(resolve => {
  const img = new Image()
  img.src = url
  img.onload = () => resolve(url)
  img.onerror = () => resolve('')
})

export const regexUrl = /^(http(s):\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/ //eslint-disable-line
export const regexMail = /^(?![.])[A-Za-z0-9._-]+(?<![.])@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,4}$/

Vue.prototype.$moment = moment
